import { render, staticRenderFns } from "./itemsxiang.vue?vue&type=template&id=7731fb20&scoped=true&"
import script from "./itemsxiang.vue?vue&type=script&lang=js&"
export * from "./itemsxiang.vue?vue&type=script&lang=js&"
import style0 from "./itemsxiang.vue?vue&type=style&index=0&id=7731fb20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7731fb20",
  null
  
)

export default component.exports